import { render, staticRenderFns } from "./EditIssue.vue?vue&type=template&id=30e64b7b&"
import script from "./EditIssue.vue?vue&type=script&lang=js&"
export * from "./EditIssue.vue?vue&type=script&lang=js&"
import style0 from "./EditIssue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports